import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useGetAdminOrganizationsList = () => {
  const organizationsEditorService = useServices().organizationsEditorService;
  return useQuery({
    queryKey: ['adminOrganizationsList'],
    queryFn: organizationsEditorService.getOrganizations,
    refetchOnWindowFocus: false,
  });
};
